import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { GtStripeService } from 'src/app/shared/services/gt-stripe.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { QueryFilter } from 'src/app/shared/models/query-filter.model';
import { InvoiceList } from '../../models/invoice-list';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'invoice-list',
    templateUrl: './invoice-list.component.html',
    styleUrl: './invoice-list.component.scss',
    standalone: false
})
export class InvoiceListComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() isActive: boolean = false;
  @Input() filter: QueryFilter = new QueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public displayedColumns: string[] = ['description', 'amountDue', 'amountPaid', 'amountRemaining', 'period', 'status', 'invoice'];
  public dataSource: InvoiceList[] = [];

  constructor(sessionService: SessionService,
    stringHelpers: StringHelpers,
    private stripeService: GtStripeService) {
    super(sessionService, stringHelpers);
    this.filter.pageSize = 15;
  }

  ngOnInit(): void {
    if (this.isActive) {
      this.getInvoices();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isActive'] && changes['isActive'].currentValue === true) {
      this.getInvoices();
    }
  }

  getInvoices(){
    this.isLoading = true;
    const data = {
      "invoiceListOptions": {
        "expand": ["data.charge", "data.customer"],
      },
      "requestOptions": {
        "stripeAccount": this.getUserFromSession().stripeAccountId
      } 
    };

    this.stripeService.getConnectAccountInvoices(data).subscribe({
      next: (res: any) => {
        this.dataSource = res.data;
        this.filter.totalCount = res.data.length;
        this.updateFilterEvent.emit(this.dataSource);
      },
      error: (err) => {
        console.log(err);
        this.isLoading = false;
      },
      complete: () => this.isLoading = false
    });
  }

  formatAmount(amount: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount / 100);
  }
}
